import { inputClassName } from "./Inputs";
import type { ChangeEvent } from "react";
import { Form } from "@circle-react-shared/uikit/Form";
import { useFormContext } from "react-hook-form";

export const AllValuesInputField = ({ name }: { name: string }) => {
  const { setValue } = useFormContext();

  const handleAllChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const newValues = {
      border_left_top_radius: value,
      border_left_bottom_radius: value,
      border_right_top_radius: value,
      border_right_bottom_radius: value,
    };
    setValue(name, newValues);
  };

  return (
    <Form.Item
      isFirstChild
      hideBorder
      hideDescription
      hideLabel
      name={`${name}.border_left_top_radius`}
      className="!p-0"
    >
      <Form.Input
        label={null}
        name={`${name}.border_left_top_radius`}
        type="number"
        min={0}
        className={inputClassName}
        onChange={handleAllChange}
      />
    </Form.Item>
  );
};
